<div class="flex flex-col gap-2 p-3" [hsLayer]="'one'">
  <hs-form-field>
    <hs-form-label>{{ itemTypeLabel }}</hs-form-label>
    <hs-select
      [options]="articleTypeOptions"
      [selectedValue]="selectedArticleType()"
      (selectionChanged)="onArticleTypeChanged($event)"
    ></hs-select>
  </hs-form-field>

  <hs-form-field>
    <hs-form-label>{{ shortTextLabel }}</hs-form-label>
    <input
      hsInput
      [placeholder]="shortTextLabel"
      [value]="title"
      (change)="onTitleChanged($event.target.value)"
    />
  </hs-form-field>

  <div class="flex flex-row w-full gap-2">
    <hs-form-field class="w-1/2">
      <hs-form-label>{{ unitLabel }}</hs-form-label>
      <hs-select
        [options]="currencyOptions"
        [selectedValue]="selectedCurrency()"
        (selectionChanged)="onCurrencyChanged($event)"
      ></hs-select>
    </hs-form-field>

    <hs-form-field class="w-1/2">
      <hs-form-label>{{ selectedArticleType() }}</hs-form-label>
      <input
        hsInput
        [type]="'number'"
        [placeholder]="selectedArticleType()"
        [value]="selectedPrice()"
        (change)="onPriceChanged($any($event.target).value)"
      />
    </hs-form-field>
  </div>

  <hs-form-field>
    <hs-form-label>{{ applyToLabel }}</hs-form-label>
    <hs-select
      [options]="applyToSelectOptions"
      [selectedValue]="applyTo()"
      (selectionChanged)="onApplyToChanged($event)"
    ></hs-select>
  </hs-form-field>

  @if (applyTo() === applyToOptions[1]) {
    <div class="flex flex-row gap-2">
      <hs-form-field class="w-1/2">
        <hs-form-label>{{ startPositionLabel }}</hs-form-label>
        <hs-select
          [options]="startItemOptions()"
          [selectedValue]="startIndexItem()"
          (selectionChanged)="onItemRangeChanged($event, true)"
        ></hs-select>
      </hs-form-field>

      <hs-form-field class="w-1/2">
        <hs-form-label>{{ endPositionLabel }}</hs-form-label>
        <hs-select
          [options]="endItemOptions()"
          [selectedValue]="endIndexItem()"
          (selectionChanged)="onItemRangeChanged($event, false)"
          [disabled]="endIndexItemDisabled()"
        ></hs-select>
      </hs-form-field>
    </div>
  } @else if (applyTo() === applyToOptions[2]) {
    <hs-form-field>
      <hs-form-label>{{ itemLabel }}</hs-form-label>
      <hs-select
        [options]="customItemOptions()"
        (selectionChanged)="onItemCustomChanged($event)"
        [disabled]="customItemSelectionDisabled()"
      ></hs-select>
    </hs-form-field>
  }

  <ng-container *ngTemplateOutlet="itemListTmpl"></ng-container>
  <ng-container *ngTemplateOutlet="sumBlockTmpl"></ng-container>

  <div class="flex flex-row w-full justify-end gap-2 p-2">
    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="outlined"
      (click)="dialogRef.close()"
    >
      {{ cancelLabel }}
    </button>
    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="filled"
      (click)="dialogRef.close(selectedArticle)"
      [disabled]="!valid()"
    >
      {{ okLabel }}
    </button>
  </div>
</div>

<ng-template #sumBlockTmpl>
  <div class="flex flex-col gap-2 m-4">
    <!-- Sum block -->
    <div class="flex flex-col gap-2 mt-2">
      <!-- Divider -->
      <div class="flex flex-row">
        <div class="w-1/3"></div>
        <div class="w-2/3">
          <hs-divider></hs-divider>
        </div>
      </div>

      <!-- Ref price -->
      <div class="flex flex-row">
        <div class="w-1/3"></div>
        <div class="w-2/3 flex flex-row">
          <div class="w-1/2 italic font-medium">{{ referenceValueLabel }}</div>
          <div class="flex w-1/2 justify-end">
            @if (showPrices) {
              <b>{{ itemsSumNetto() | number: '1.2-2' }}€</b>
            } @else {
              <b>***</b>
            }
          </div>
        </div>
      </div>

      <!-- Divider -->
      <div class="flex flex-row">
        <div class="w-1/3"></div>
        <div class="w-2/3">
          <hs-divider></hs-divider>
        </div>
      </div>

      <div class="flex flex-row">
        <div class="w-1/3"></div>
        <div class="w-2/3 flex flex-row">
          <div class="w-1/2">
            {{ selectedArticleType() }}
          </div>
          <div class="flex w-1/2 justify-end">
            {{ price() | number: '1.2-2' }}€
          </div>
        </div>
      </div>

      <div class="flex flex-row">
        <div class="w-1/3"></div>
        <div class="flex flex-col gap-1 w-2/3">
          <hs-divider></hs-divider>
          <hs-divider></hs-divider>
        </div>
      </div>

      <div class="flex flex-row">
        <div class="w-1/3"></div>
        <div class="w-2/3 flex flex-row">
          <div class="w-1/2 font-medium">{{ totalLabel }}</div>
          <div class="flex w-1/2 justify-end font-medium">
            @if (showPrices) {
              {{ itemsSumFull() | number: '1.2-2' }}€
            } @else {
              ***
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #itemListTmpl let-node="ctxNode">
  @if (selectedItems().length > 0) {
    <div class="flex flex-col gap-2 max-h-80 overflow-y-scroll">
      <div class="font-semibold">{{ selectedItemsLabel }}</div>
      @for (item of selectedItems(); track item) {
        <div class="flex flex-row gap-4 ml-2 mr-2 items-center">
          <hs-icon [width]="24" [height]="24" [innerHTML]="cartIcon"></hs-icon>
          <div class="flex flex-col">
            <div class="font-normal text-base">{{ getItemHeader(item) }}</div>
            <div
              class="font-light text-sm"
              [innerHTML]="getItemSubHeader(item)"
            ></div>
          </div>

          @if (applyTo() === applyToOptions[2]) {
            <span class="flex-1"></span>
            <button mat-icon-button (click)="onRemoveItemClicked(item.uId)">
              <hs-icon
                [width]="24"
                [height]="24"
                [innerHTML]="trashIcon"
              ></hs-icon>
            </button>
          }
        </div>
      }
    </div>
  }
</ng-template>
